/* components/ui/AttachmentChip.jsx — чип вложения (S5).
   Используется в строке Composer (с × удалить, статусы uploading/error)
   и под пузырём user в ленте (inFeed: без ×, кликабелен → открыть).
   Источник: 06 §2.6b. ХЕНДОФФ: → frontend/components/common/AttachmentChip.jsx. */

import { Icon } from './Icon.jsx';

  function fileIcon(mime, name) {
    const m = (mime || '').toLowerCase();
    const n = (name || '').toLowerCase();
    if (m.startsWith('image/') || /\.(png|jpe?g|gif|webp|heic)$/.test(n)) return 'image';
    if (m === 'application/pdf' || n.endsWith('.pdf')) return 'file-text';
    if (/\.(xlsx?|csv)$/.test(n) || m.includes('sheet') || m.includes('excel')) return 'reports';
    if (/\.(docx?|rtf)$/.test(n) || m.includes('word')) return 'file-text';
    return 'file';
  }

  function fmtBytes(b) {
    if (b == null) return '';
    if (b < 1024) return b + ' Б';
    if (b < 1024 * 1024) return Math.round(b / 1024) + ' КБ';
    return (b / 1048576).toFixed(1).replace('.0', '') + ' МБ';
  }

  function AttachmentChip({ file, onRemove, inFeed = false }) {
    const error = file.error;
    const uploading = file.uploading;
    const cls = 'att-chip'
      + (error ? ' att-chip--error' : '')
      + (uploading ? ' att-chip--uploading' : '')
      + (inFeed ? ' att-chip--feed' : '');

    const inner = (
      <>
        <span className="att-chip__icon">
          {uploading ? <Icon name="spinner" size={14} /> : <Icon name={error ? 'alert-triangle' : fileIcon(file.mime, file.name)} size={14} />}
        </span>
        <span className="att-chip__body">
          <span className="att-chip__name truncate">{file.name}</span>
          {error ? <span className="att-chip__meta att-chip__meta--error">{error}</span>
                 : (file.size != null && <span className="att-chip__meta num">{fmtBytes(file.size)}</span>)}
        </span>
      </>
    );

    // в ленте — кликабельный (открыть в новой вкладке), без ×
    if (inFeed) {
      return (
        <a className={cls} href={file.url || '#'} target="_blank" rel="noopener noreferrer" title={file.name}>
          {inner}
        </a>
      );
    }

    return (
      <span className={cls} title={file.name}>
        {inner}
        {onRemove && (
          <button className="att-chip__x" onClick={onRemove} aria-label={`Удалить ${file.name}`}>
            <Icon name="close" size={12} />
          </button>
        )}
      </span>
    );
  }

export { AttachmentChip };
export { fmtBytes };
